export const selectedEggTypeKey: string = "performance_pro_selectedeggtype";

export const selectedDateKey: string = "performance_pro_selecteddate";

export const selectedDatePeriodKey: string =
  "performance_pro_selecteddateperiod";

export const askForFeedbackKey: string = "user_askforfeedback";
